import { VALIDATORS } from "./Constants"
export const VALIDATOR_TYPES = {
    PHONE: 'PHONE'
};

const VALIDATE_REGX = {
    PHONE_REGX: /^\d{10}$/,
    PHONE_REGX_11: /^\d{11}$/
}
const isValidPhone = (field: any) => {

    if (field?.validators?.type) {
        const formatNo = field.value ? field.value.replace(/\D/g, '') : "";

        return formatNo.match(VALIDATE_REGX.PHONE_REGX) || formatNo.match(VALIDATE_REGX.PHONE_REGX_11);
    }

    return true;
}
const isValidLength = (value: any, length: number) => {
    return value && value.toString().length >= length;
}

const isValidRegex = (value: any, regex: any) => {
    try {
        return new RegExp(regex).test(value);
    } catch (error) {
    }
    return false;
}
export const validateField = (field: any) => {
    let hasError = false;
    if (field.validators) {
        Object.keys(field.validators).forEach((key: any) => {
            if (!hasError && key === VALIDATORS.TYPE && !isValidPhone(field)) {
                hasError = true;
            }
            if (!hasError && key === VALIDATORS.MIN_LENGTH && !isValidLength(field.value, field.validators.minLength)) {
                hasError = true;
            }
            if (!hasError && key === VALIDATORS.REGEX && !isValidRegex(field.value, field.validators.regex)) {
                hasError = true;
            }
        });
    }
    return hasError;
}